export const en = {
  COMPONENT: {
    SELECT: {
      all: 'All',
      search: 'Search',
      no_results: 'No results',
      others: '(+{{value}} others)',
      loading: 'Loading...',
    },
  },
};
